import { History } from "lucide-react";

const fmtDateTime = (value) => {
  if (!value) return "—";
  try { return new Date(value).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" }); }
  catch { return value; }
};

export const RevisionHistory = ({ items = [], testIdPrefix = "revision" }) => {
  if (!items.length) return null;
  return (
    <section className="revision-history" data-testid={`${testIdPrefix}-history`}>
      <div className="revision-history-title"><History size={13} /> RIWAYAT CATATAN PERBAIKAN <span>{items.length}</span></div>
      <ol>
        {items.map((item, index) => <li key={item.revision_id || `${item.created_at}-${index}`} data-testid={`${testIdPrefix}-history-item-${index + 1}`}>
          <div className="revision-history-marker">{item.sequence || index + 1}</div>
          <div><p>{item.notes}</p><small>{item.created_by || "Admin"} · {fmtDateTime(item.created_at)}</small></div>
        </li>)}
      </ol>
    </section>
  );
};